const INTL_ORDINAL_SUFFIXES = new Map([
  ["one", "st"],
  ["two", "nd"],
  ["few", "rd"],
  ["other", "th"],
]);

export const numberWithOrdinal = (n: number): string => {
  const enOrdinalRules = new Intl.PluralRules("en-US", { type: "ordinal" });
  const rule = enOrdinalRules.select(n);
  const suffix = INTL_ORDINAL_SUFFIXES.get(rule);

  return `${n}${suffix}`;
};

export const formatNumber = (number) => {
  if (number) {
    return typeof window !== "undefined" && new window.Intl.NumberFormat("en-US").format(number);
  }
  if (number == 0) {
    return 0;
  }
  return "";
};

export function formatNumberFraction(number, scale = 2) {
  return parseFloat(number).toFixed(number % 1 === 0 ? 0 : scale);
}

export const getPercentageValue = (value, total, scale = 2) =>
  total && formatNumberFraction((value / total) * 100, scale);
